// extracted by mini-css-extract-plugin
module.exports = {"black":"buttons_black__6KJOy","white":"buttons_white__1cYIa","without_showdow":"buttons_without_showdow__3eHYy"};